import React from 'react'
import { Link } from "react-router-dom";

import Logo from '../../others/Logo';

const DesktopNav = () => {
  return (
    <>
      <header className="headed laptop">
        <div className="lap-nav">
          <Logo />
          <ul className='main-menu'>
            <li><Link to={`/`}> Home </Link></li>
            <li><Link to={`/sign-in`}> Account </Link></li>
            <li><Link to={`/sign-in`}> Savings </Link></li>
            <li><Link to={`/investments`}> Investment </Link></li>
            <li><Link to={`/loan`}> Loan </Link></li>
          </ul>
        </div>

      </header>
    </>
  )
}

export default DesktopNav